import script from "./app-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./app-banner.vue?vue&type=script&setup=true&lang=js"

import "./app-banner.vue?vue&type=style&index=0&id=54994bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54994bc2"]])

export default __exports__